import React from 'react';
import $ from 'jquery';
import i18next from 'i18next';

import Constants from './../constants';
import EpisodeThumbnail from './episodeThumbnail';

module.exports = React.createClass({

  componentDidMount: function componentDidMount() {
    document.title = i18next.t('ourPicks') + ' | ' + i18next.t('frequencyAsia');
    $.getJSON(`${Constants.API_URL}episodes/recommended/${this.state.currentPage}`)
      .done((data) => {
        this.setState({ episodes: data.episodes });
      });
  },

  getInitialState: function getInitialState() {
    return {
      episodes: [],
      currentPage: 1,
    };
  },


  render: function render() {
    return (
      <div className="o-content-block">
        <section className="c-content">
          <div className="row">
            <div className="col">
              <h1>{ i18next.t('ourPicks') }</h1>
              { this.state.episodes.map((episode) => {
                return <EpisodeThumbnail key={ episode.id } { ...episode } />;
              }) }
            </div>
          </div>
        </section>
      </div>
    );
  },
});
